const headerItems = document.querySelectorAll(".header__menu_item_dropdown")
const headerMenu = document.querySelector(".header__menu")

if (headerItems.length > 0 && headerMenu) {
    headerItems.forEach(item => {
        item.addEventListener("click", () => {
            if (item.parentElement.classList.contains("active")) {
                headerItems.forEach(item => {
                    item.parentElement.classList.remove("active")
                    headerMenu.classList.remove("open-child")
                })
                document.body.classList.remove("open-menu")
            } else {
                headerItems.forEach(item => {
                    item.parentElement.classList.remove("active")
                })
                item.parentElement.classList.add("active")
                document.body.classList.add("open-menu")
                headerMenu.classList.add("open-child")
            }
        })
    })
}

if (document.querySelector(".header_overlay")) {
    document.querySelector(".header_overlay").addEventListener("click", () => {
        if (headerItems.length > 0 && headerMenu) {
            headerItems.forEach(item => {
                item.parentElement.classList.remove("active")
            })
            document.body.classList.remove("open-menu")
            headerMenu.classList.remove("open")
            headerMenu.classList.remove("open-child")
        }
    })
}

const mobileMenuBtn = document.querySelector(".header__open-menu")
const closeMobileMenu = document.querySelector(".header__menu_title_close")
const backMobileMenu = document.querySelectorAll(".header__child_menu__back")

if (mobileMenuBtn && headerMenu) {
    mobileMenuBtn.addEventListener("click", () => {
        if (headerItems.length > 0) {
            headerItems.forEach(item => {
                item.parentElement.classList.remove("active")
            })
        }
        document.body.classList.toggle("open-menu")
        headerMenu.classList.remove("open-child")
        headerMenu.classList.toggle("open")
    })
}

if (closeMobileMenu && headerMenu) {
    closeMobileMenu.addEventListener("click", () => {
        if (headerItems.length > 0) {
            headerItems.forEach(item => {
                item.parentElement.classList.remove("active")
            })
        }
        document.body.classList.remove("open-menu")
        headerMenu.classList.remove("open")
    })
}

if (backMobileMenu.length > 0 && headerMenu) {
    backMobileMenu.forEach(item => {
        item.addEventListener("click", () => {
            if (headerItems.length > 0) {
                headerItems.forEach(item => {
                    item.parentElement.classList.remove("active")
                })
            }
            headerMenu.classList.remove("open-child")
        })
    })
}
